/**
 * Display-only AZN prices for the activities catalog and related marketing copy.
 * Checkout amounts come from the API; these overrides keep UI aligned with published tariffs.
 */

/** Metropolitango championship section headers (activities page). */
export const DISPLAY_CHAMPIONSHIP_METROPOLITANGO_AZN = {
  national: 56,
  international: 65,
  /** Early-bird strikethrough in section header (before 1 June). */
  nationalMarketingEarly: 74,
  internationalMarketingEarly: 74,
} as const;

/** Baku Tango Trophy header price. */
export const DISPLAY_CHAMPIONSHIP_BAKU_AZN = {
  price: 56,
  marketingEarly: 74,
} as const;

/** Standard milongas (opening, grand without orchestra, farewell). */
export const DISPLAY_MILONGA_SOLO_STANDARD_AZN = 93;

/** Couple ticket for standard milongas (not 2× solo). */
export const DISPLAY_MILONGA_COUPLE_STANDARD_AZN = 168;

/** Milonga passes on the landing (marketing). */
export const DISPLAY_MILONGA_PASS_5_EVENINGS_AZN = 370;
export const DISPLAY_MILONGA_PASS_COUPLE_AZN = 629;

/** Paid group master class slot. */
export const DISPLAY_WORKSHOP_GROUP_AZN = 56;

/** Private lessons on the landing: min (Ornella) – max across maestro slots. */
export const DISPLAY_WORKSHOP_PRIVATE_ORNELLA_AZN = 222;
export const DISPLAY_WORKSHOP_PRIVATE_MAX_AZN = 296;

export function isOrnellaPrivateLessonLabel(...parts: Array<string | undefined | null>): boolean {
  return parts.some((p) => /ornella/i.test((p ?? '').trim()));
}
